module.exports = __webpack_public_path__ + "static/media/ico-discount.69baa950.svg";